var _defs, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 137.1 137.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #223c6a;\r\n      }\r\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 68.1,
    cy: 69.3,
    r: 65.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.7,41.9c-3.5-8.2-8.4-15.5-14.7-21.8-6.3-6.3-13.6-11.2-21.8-14.7-8.5-3.6-17.4-5.4-26.7-5.4s-18.2,1.8-26.7,5.4c-8.2,3.5-15.5,8.4-21.8,14.7-6.3,6.3-11.2,13.6-14.7,21.8C1.8,50.3,0,59.3,0,68.5s1.8,18.2,5.4,26.7c3.5,8.2,8.4,15.5,14.7,21.8,6.3,6.3,13.6,11.2,21.8,14.7,8.5,3.6,17.4,5.4,26.7,5.4s18.2-1.8,26.7-5.4c8.2-3.5,15.5-8.4,21.8-14.7,6.3-6.3,11.2-13.6,14.7-21.8,3.6-8.5,5.4-17.4,5.4-26.7s-1.8-18.2-5.4-26.7ZM68.5,132.7c-35.4,0-64.2-28.8-64.2-64.2S33.1,4.3,68.5,4.3s64.2,28.8,64.2,64.2-28.8,64.2-64.2,64.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.3,66.4h-36.7V29.7c0-1.2-1-2.2-2.2-2.2s-2.2,1-2.2,2.2v36.7H29.7c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2h36.7v36.7c0,1.2,1,2.2,2.2,2.2s2.2-1,2.2-2.2v-36.7h36.7c1.2,0,2.2-1,2.2-2.2s-1-2.2-2.2-2.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.91a525a5078ce4a8088c788c11606a45.svg";
export { ForwardRef as ReactComponent };